import { useSelector } from "react-redux";
import { useEffect } from "react";
import { Box, Pagination, CircularProgress } from "@mui/material";
import TasksControls from "./tasks/TasksControls";
import TasksTable from "./tasks/TasksTable";
import useTasksAnalytics from "./tasks/useTasksAnalytics";

const TasksAnalytics = ({
  onSwitchTab,
  onSetMessageRecipient,
  initialSearchTerm,
  onClearSearchTerm,
}) => {
  const {
    tasks = [],
    users = [],
    loading,
  } = useSelector((state) => state.admin);
  const {
    searchTerm,
    sortBy,
    sortOrder,
    page,
    rowsPerPage,
    processedTasks,
    paginatedTasks,
    setSearchTerm,
    setRowsPerPage,
    setPage,
    handleSort,
    getUserName,
    getUserEmail,
  } = useTasksAnalytics(tasks, users);

  // Apply initial search term when provided (e.g., from "View Tasks" action)
  useEffect(() => {
    if (initialSearchTerm) {
      setSearchTerm(initialSearchTerm);
      // Clear the initial search term after applying
      if (onClearSearchTerm) {
        onClearSearchTerm();
      }
    }
  }, [initialSearchTerm, setSearchTerm, onClearSearchTerm]);

  const handleMessageUser = (userId) => {
    onSwitchTab("6"); // Messaging tab
    onSetMessageRecipient(userId);
  };

  if (loading?.tasks) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 300,
        }}
      >
        <CircularProgress size={64} />
      </Box>
    );
  }

  return (
    <Box>
      {/* Search and Controls */}
      <TasksControls
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={setRowsPerPage}
        totalTasks={processedTasks.length}
      />

      {/* Tasks Table */}
      <TasksTable
        tasks={paginatedTasks}
        sortBy={sortBy}
        sortOrder={sortOrder}
        onSort={handleSort}
        getUserName={getUserName}
        getUserEmail={getUserEmail}
        onMessageUser={handleMessageUser}
      />

      {/* Pagination */}
      {processedTasks.length > rowsPerPage && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Pagination
            count={Math.ceil(processedTasks.length / rowsPerPage)}
            page={page}
            onChange={(e, newPage) => setPage(newPage)}
            color="primary"
            showFirstButton
            showLastButton
          />
        </Box>
      )}
    </Box>
  );
};

export default TasksAnalytics;
